<template>
  <div class="skills" id="skills">
    <b-row style="align-items: flex-start">
      <b-col cols="12" md="3" class="title">
        <h1 ref="title">|skills</h1>
      </b-col>
      <b-col cols="12" md="7">
        <div class="skill">
          <b-button-group v-for="(skill, i) in skillSet" :key="i">
            <b-button
              class="btn_icon"
              :style="{
                color: skill.color,
                border: '1px solid ' + skill.color,
              }"
            >
              {{ skill.area }}
            </b-button>
            <b-button
              class="bar"
              :style="{
                backgroundColor: skill.color + '80',
                border: '1px solid ' + skill.color,
              }"
            >
              <div
                :style="{
                  width: skill.initLevel + '%',
                  backgroundColor: skill.color,
                }"
              ></div>
            </b-button>
          </b-button-group>
          <div class="stand-for">
            * B: Bootstrap, M: Material UI, A: Ant Design, T: Tailwind
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      intervalID: "",
      increment: 1,
      skillSet: [
        { area: "reactjs", initLevel: 0, level: 80, color: "#0f5ea0" },
        { area: "nextjs", initLevel: 0, level: 80, color: "#0f5ea0" },
        { area: "javascript", initLevel: 0, level: 80, color: "#0f5ea0" },
        { area: "typescript", initLevel: 0, level: 60, color: "#0f5ea0" },
        { area: "redux", initLevel: 0, level: 70, color: "#0f5ea0" },
        { area: "mongodb", initLevel: 0, level: 50, color: "#0f5ea0" },
        { area: "nodejs", initLevel: 0, level: 50, color: "#0f5ea0" },
        { area: "vuejs", initLevel: 0, level: 60, color: "#0f5ea0" },
        { area: "css/scss", initLevel: 0, level: 80, color: "#0f5ea0" },
        { area: "b, m, a, t", initLevel: 0, level: 80, color: "#0f5ea0" },
      ],
      scrollListener: this.onScroll.bind(this),
      trigger: false,
    };
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollListener);
  },
  methods: {
    getLevelProgress: function (value) {
      this.skillSet.forEach((data) => {
        data.initLevel = Math.min(
          Math.floor(data.initLevel + value),
          data.level
        );
      });
    },
    onScroll() {
      const rect = this.$refs.title.getBoundingClientRect();
      this.trigger =
        this.trigger || rect.top + rect.height < window.innerHeight;
    },
  },
  watch: {
    trigger(v) {
      if (v) {
        this.intervalID = setInterval(() => {
          this.getLevelProgress(this.increment);
        }, 10);
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.intervalID);
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style scoped lang="scss">
@import "../styles/views/Skills.scss";
</style>
